import { overlay } from 'overlay-kit';
import type { SaveQuizTarget, SaveToFolderOptions } from './types/saveQuizLocation.types';

/**
 * 저장 위치 선택 모달을 연다.
 *
 * 무엇을 할지는 부르는 쪽이 `intent` 로 정한다 — `copy` 면 사본을 만들고 `move` 면 소속만 바꾼다.
 * `options` 로 갈 수 있는 곳을 좁힌다(`privateOnly`).
 */
export async function showSaveToFolderModal(quiz: SaveQuizTarget, options?: SaveToFolderOptions) {
  const {
    SaveToFolderModal
  } = await import('./components/SaveToFolderModal');
  overlay.open(({
    unmount
  }) => <SaveToFolderModal quiz={quiz} options={options} onClose={unmount} />, {
    overlayId: 'save-to-folder-modal'
  });
}